import React, { useRef } from 'react';
import Header from './Header/Header';
import styles from './NavigationOverlay.module.scss';

function NavigationOverlay() {
  const navRef = useRef(null);

  return (
    <div className={styles.overlay} ref={navRef}>
      <Header />
    </div>
  );
}

export default NavigationOverlay;
